var CoinRedeemSku;
(function (CoinRedeemSku) {
    CoinRedeemSku["AmazonFireCube"] = "amazon-fire-tv-cube-sweepstakes";
    CoinRedeemSku["CoinFeedback"] = "coin-feedback-survey";
    CoinRedeemSku["CoinPro"] = "coin-pro-offer";
    CoinRedeemSku["CosoriSmartAirFryer"] = "cosori-smart-air-fryer-sweepstakes";
    CoinRedeemSku["GoPro"] = "gopro-hero9-sweepstakes";
    CoinRedeemSku["IPad"] = "apple-ipad-10.2inch-32gb-sweepstakes";
    CoinRedeemSku["NintendoSwitch"] = "nintendo-switch-sweepstakes";
    CoinRedeemSku["NintendoSwitchBundle"] = "nintendo-switch-bundle-sweepstakes";
    CoinRedeemSku["Oculus"] = "oculus-quest-2-sweepstakes";
    CoinRedeemSku["OneMillionXyoTokens"] = "one-million-xyo-sweepstakes";
    CoinRedeemSku["PlayStation5"] = "sony-playstation-5-sweepstakes";
    CoinRedeemSku["RihannaGuitar"] = "rihanna-signed-fender-guitar-sweepstakes";
    CoinRedeemSku["Samsung65Inch"] = "samsung-65inch-4k-tv-sweepstakes";
    CoinRedeemSku["SentinelXNfc"] = "sentinel-x-nfc-offer";
    CoinRedeemSku["XboxSeriesX"] = "microsoft-xbox-x-sweepstakes";
})(CoinRedeemSku || (CoinRedeemSku = {}));
export default CoinRedeemSku;
